export default __webpack_public_path__ + "static/international-metric-desktop-117fbeb4740b1484544fa13cfd4b9dc9.svg";